window.addEventListener('DOMContentLoaded', function () {

	gsap.registerPlugin(ScrollTrigger, SplitText);

	ScrollTrigger.config({ ignoreMobileResize: true });

	const isMobile = window.innerWidth < 768;
	const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

	let mm = gsap.matchMedia();

	mm.add("(min-width: 767px", () => {
		gsap.from('.intro__body', { autoAlpha: 0 });
		gsap.from('.intro__content', { opacity: 0, yPercent: 200, delay: .3, duration: 1 });
	});

	//titles animation
	const titles = document.querySelectorAll('.js-title-animate');

	titles.forEach(item => {

		const itemSplit = SplitText.create(item, { type: "words, chars" });

		let tl = gsap.from(itemSplit.chars, {
			opacity: 0,
			duration: isMobile ? .45 : .7,
			yPercent: 50,
			ease: "back(2)",
			stagger: { each: isMobile ? 0.012 : 0.02 }
		});

		ScrollTrigger.create({
			trigger: item,
			start: isMobile ? "top 95%" : "top 90%",
			toggleActions: "play none none reverse",
			animation: tl,
			refreshPriority: -item.dataset.index
		})
	});


	//buttons animation
	const buttons = document.querySelectorAll('.js-button-animate');

	buttons.forEach(button => {
		let tlButton = gsap.from(button, {
			opacity: 0,
			duration: isMobile ? .6 : 1,
			y: 50,
			clipPath: 'inset(100%)',
			ease: "back",
		});

		ScrollTrigger.create({
			trigger: button,
			start: "top 95%",
			toggleActions: "play none none reverse",
			animation: tlButton,
			refreshPriority: -button.dataset.index
		})
	});



	//move animation
	const moveElems = document.querySelectorAll('.js-move-animate');

	mm.add("(min-width: 992px", () => {
		moveElems.forEach(elem => {
			gsap.set(elem, { yPercent: -15 });

			gsap.to(elem, {
				yPercent: 15,
				ease: "none",
				scrollTrigger: {
					trigger: elem,
					scrub: 1,
					refreshPriority: -elem.dataset.index
				}
			});
		})
	});



	//brain animation
	gsap.set('.brain-box__title', { scale: 0 });

	document.querySelectorAll(".brain-label").forEach((label) => {
		const parentIsFirst = label.closest(".brain-group__item") === document.querySelector(".brain-group__item:first-child");
		gsap.set(label, {
			xPercent: isMobile
				? gsap.utils.random(-20, 20)
				: (parentIsFirst ? gsap.utils.random(100, 250) : gsap.utils.random(-250, -100)),
			yPercent: isMobile
				? gsap.utils.random(-15, 15)
				: gsap.utils.random(-40, 40),
			opacity: 0,
			scale: 0
		});
	});

	let tlBrainImg = gsap.timeline({
		scrollTrigger: {
			trigger: '.brain-container',
			start: "15% bottom",
			end: "top top",
			scrub: 1,
			refreshPriority: -2
		}
	});
	tlBrainImg.from(".brain-box__img", { yPercent: 25, scale: 0, ease: "sine.in" })


	const brainContainer = document.querySelector('.brain-container');
	const brainBox = document.querySelector('.brain-box');

	const brainBg = document.querySelector('.brain-container__bg');

	// Hide bg initially on mobile — it will fade in as part of the animation
	if (brainBg && isMobile) {
		gsap.set(brainBg, { opacity: 0 });
	}

	let tlBrain = gsap.timeline({
		scrollTrigger: {
			trigger: '.brain-container',
			start: "top top",
			// На мобільному коротша прокрутка — анімація швидша і не «з'їдає» так багато скролу
			end: isMobile ? "+=160%" : "+=350%",
			pin: true,
			pinReparent: true,
			anticipatePin: 1,
			scrub: isMobile ? 1 : 2,
			refreshPriority: -2
		}
	});

	// Buffer entry — менший на мобільному, щоб анімація стартувала раніше
	tlBrain.to('.brain-container', { duration: isMobile ? 0.5 : 1.5, x: 0 });
	if (brainBg && isMobile) {
		tlBrain.to(brainBg, { opacity: 1, duration: 1, ease: "sine.out" }, "<");
	}

	tlBrain.to(".brain-label", { opacity: 1, scale: 1, stagger: 0.2, ease: "sine.out", force3D: true }, "-=0.2")
		.to(".brain-label", { xPercent: 0, yPercent: 0, ease: "power2.inOut", force3D: true }, "-=0.5")
		.to('.brain-box__title', { scale: 1, ease: "sine.out", force3D: true }, "-=0.2")
		// Buffer exit — менший на мобільному
		.to('.brain-container', { duration: isMobile ? 0.5 : 1.5, x: 0 });



	// LENIS init — disabled on mobile and Safari (both conflict with GSAP pin)
	if (!isMobile && !isSafari) {
		const lenis = new Lenis();
		window.lenis = lenis;

		// Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
		lenis.on('scroll', ScrollTrigger.update);

		// Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
		gsap.ticker.add((time) => {
			lenis.raf(time * 1000);
		});

		// Disable lag smoothing in GSAP to prevent any delay in scroll animations
		gsap.ticker.lagSmoothing(0);
	}

});